// extracted by mini-css-extract-plugin
module.exports = {"aino-chat-btn":"AinoChatButton_aino-chat-btn__Ptxt_"};